import { List as ListMui, ListProps as ListPropsMui } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

export type ListProps = ListPropsMui;

export const List = forwardRef(
  ({ ...rest }: ListProps, ref: ForwardedRef<HTMLUListElement>) => (
    <ListMui {...rest} ref={ref} />
  ),
);
